/**
 * Constants for Room Settings Modal
 */

// Page identifiers
export const ROOM_SETTINGS_PAGES = {
  SECURITY: 'security',
  PERMISSIONS: 'permissions',
  NOTIFICATIONS: 'notifications',
};

// Power level constants
export const POWER_LEVELS = {
  CUSTOM: -1, // Marker for custom input
  DEFAULT: 0,
  MODERATOR: 50,
  ADMIN: 100,
};

// Power level options for dropdowns
export const POWER_LEVEL_OPTIONS = [
  { value: POWER_LEVELS.DEFAULT, label: 'Default' },
  { value: POWER_LEVELS.MODERATOR, label: 'Moderator' },
  { value: POWER_LEVELS.ADMIN, label: 'Admin' },
  { value: POWER_LEVELS.CUSTOM, label: 'Custom Level' },
];

// Join rule constants
export const JOIN_RULES = {
  INVITE: 'invite', // Only invited users can join
  PUBLIC: 'public',  // Anyone can join
};

// History visibility constants
export const HISTORY_VISIBILITY = {
  INVITED: 'invited',       // Visible from invitation
  JOINED: 'joined',         // Visible from joining
  SHARED: 'shared',         // Visible for all participants
  WORLD_READABLE: 'world_readable', // Visible for everyone
};

// Permission event types
// Note: Per Matrix spec, message events use events_default, not events['m.room.message']
// See: https://spec.matrix.org/v1.11/client-server-api/#mroompower_levels
export const PERMISSION_EVENTS = {
  DEFAULT: 'users_default',
  SEND_MESSAGE: 'events_default', // Controls m.room.message and other message events
  CONFIGURE: 'state_default',
  BAN: 'ban',
  KICK: 'kick',
  REDACT: 'redact',
  INVITE: 'invite',
  HISTORICAL: 'events.m.room.history_visibility',
};

// Labels for permission functions
export const PERMISSION_LABELS = {
  [PERMISSION_EVENTS.DEFAULT]: 'Default permission level',
  [PERMISSION_EVENTS.SEND_MESSAGE]: 'Send messages',
  [PERMISSION_EVENTS.CONFIGURE]: 'Configure chat',
  [PERMISSION_EVENTS.BAN]: 'Ban from chat',
  [PERMISSION_EVENTS.KICK]: 'Kick from chat',
  [PERMISSION_EVENTS.REDACT]: 'Delete message',
  [PERMISSION_EVENTS.INVITE]: 'Invite contact',
  [PERMISSION_EVENTS.HISTORICAL]: 'Historical',
};
